import { render, staticRenderFns } from "./videoNote.vue?vue&type=template&id=1b82f132&scoped=true&"
import script from "./videoNote.vue?vue&type=script&lang=js&"
export * from "./videoNote.vue?vue&type=script&lang=js&"
import style0 from "./videoNote.vue?vue&type=style&index=0&id=1b82f132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b82f132",
  null
  
)

export default component.exports